export default "__VITE_ASSET__b5ea3b8e__"